// Modal.js
import React from 'react';
import './Modal.css';
const Modal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Confirm Reset Password</h2>
                <p>Are you sure you want to reset the password?</p>
                <button className="primary" onClick={onConfirm}>Yes</button>
                <br />
                <button className="secondary" onClick={onClose}>No</button>
            </div>
        </div>
    );
};

export default Modal;
